/**
 * ORION — Observability Domain
 *
 * File: observabilityService.ts
 *
 * Responsibility:
 * - Frontend Service layer for fetching historical event data (Replay).
 * - Defines the CognitiveEvent schema.
 *
 * What this file does NOT do:
 * - Does not handle real-time streams (useObjectStream does that).
 */
import axios from 'axios';
import { getToken } from '../../utils/auth';

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:8000';

const client = axios.create({
    baseURL: API_URL
});

// Interceptor to add token
client.interceptors.request.use(config => {
    const token = getToken();
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

export interface CognitiveEvent {
    event_id: string;
    event_type: string;
    timestamp: string;
    payload: any;
    actor_id: string;
    sequence_number: number;
}

export const observabilityService = {
    /**
     * Get chronological timeline of events for a cognitive object.
     */
    async getReplay(objectId: string): Promise<CognitiveEvent[]> {
        return (await client.get<CognitiveEvent[]>(`/cognition/objects/${objectId}/replay`)).data;
    }
};
